export const USER_EVENTS = {
  READ_MORE: 'web_nav_read_more',
  SELECT_METRIC_VALUE: 'web_select_metric_value',
  TOGGLE_METRICS: 'web_toogle_metrics',
  SELECTED_EXPORT_METRIC: 'web_selected_export_metric',
  USDA_COUNTRY_DROPDOWN_SELECTION: 'web_usdaCountryDropDownSelection',
  LOGIN: 'web_login',
  CREATE_ACCOUNT: 'web_create_account',
  NAV_FORGOT_PASSWORD: 'web_nav_forgot_password',
  SUBMIT_FORGOT_PASSWORD_SUCCESS: 'web_submit_forgotPassword',
  LOGIN_HERE: 'web_nav_login_here',
  STATUS: 'web_status',
  NAV_BUY_SUBSCRIPTION: 'web_nav_buy_now',
  SUBSCRIPTION_DETAILS_UPDATED: 'web_subscription_details_updated',

  // Payment-RazorPay
  PAYMENT_INITIATED_RAZORPAY: 'web_payment_razorpay_initiated',
  PAYMENT_ORDER_CREATED_RAZORPAY: 'web_payment_razorpay_order_created',
  PAYMENT_SUCCESS_RAZORPAY: 'web_payment_razorpay_success',
  PAYMENT_FAILED_RAZORPAY: 'web_payment_razorpay_order_failed',
  PAYMENT_FAIL_RAZORPAY: 'web_payment_razorpay_failed',
  PAYMENT_CREATION_FAILED_RAZORPAY: 'web_payment_razorpay_creation_failed',

  // Payment-PayPal
  PAYMENT_ORDER_CREATED_PAYPAL: 'web_payment_paypal_order_created',
  PAYMENT_ORDER_SUCCESS_PAYPAL: 'web_payment_paypal_success',
  PAYMENT_ORDER_FAILED_PAYPAL: 'web_payment_paypal_order_failed',
  PAYMENT_CREATION_FAILED_PAYPAL: 'web_payment_paypal_creation_failed',

  // Payment-Stripe
  PAYMENT_ORDER_CREATED_STRIPE: 'web_payment_stripe_order_created',
  PAYMENT_ORDER_SUCCESS_STRIPE: 'web_payment_stripe_success',
  PAYMENT_ORDER_FAILED_STRIPE: 'web_payment_stripe_order_failed',
  PAYMENT_CREATION_FAILED_STRIPE: 'web_payment_stripe_creation_failed',

  // Profile
  PROFILE_SCREEN: 'web_profile_screen',
  PROFILE_MY_INFO_NAV: 'web_nav_my_info',
  PROFILE_SETTINGS_NAV: 'web_nav_profile_settings',
  PROFILE_CHANGE_PASSWORD_NAV: 'web_nav_profile_change_password',
  PROFILE_ACCOUNT_ACTIVITY_NAV: 'web_nav_profile_activity',

  PROFILE_MY_INFO_SAVE: 'web_profile_info_save',
  PROFILE_SETTINGS_SAVE: 'web_profile_settings_save',
  PROFILE_CHANGE_PASSWORD: 'web_profile_change_password',

  SELECT_LANGUAGE_PREFERENCE: 'web_select_language',
  SELECT_LANDING_PAGE: 'web_select_landing_page',
  SELECT_DATE_FORMAT: 'web_select_date_format',
  SELECT_TIME_FORMAT: 'web_select_time_format',
  SELECT_TIME_ZONE: 'web_select_time_zone',
  NOTIFICATION_TOGGLE: 'web_enable_notification_btn',

  DEACTIVATE_ACCOUNT: 'web_deactivate_account',
  DELETE_ACCOUNT: 'web_delete_account',

  // Notification
  NOTIFICATION_SEE_ALL_NAV: 'web_see_all_notification_nav',
  NOTIFICATION_CLICK: 'web_notification_item_click',

  // Logout
  PROFILE_LOGOUT_BTN: 'web_profile_logout_btn',

  // About CoffeeWeb
  ABOUT_US_COUNTRY_DROPDOWN: 'web_about_us_country_dropdown',
  ABOUT_US_CLOCK_SETTINGS: 'web_about_us_clock_settings',

  // Coffee Quotes
  COFFEE_QUOTES_CONTRACT: 'web_coffee_quotes_contract',
  COFFEE_QUOTES_FOREX: 'web_coffee_quotes_forex',
  COFFEE_QUOTES_WORKBOOK: 'web_coffee_quotes_workbook',

  FOREX_CURRENCY_TAP: 'web_forex_currency_tap',

  // Coffee News Feed
  GUEST_NEWS_FEED_LANGUAGE_CHANGE: 'web_guest_news_feed_language_change',
  GUEST_NEWS_FEED_SEARCH_NEWS: 'web_guest_news_feed_search_news',

  NEWS_FEED_SEARCH_NEWS: 'web_news_feed_search_news',
  NEWS_FEED_FAVOURITE_NEWS: 'web_favorite_News',
  NEWS_FEED_LANGUAGE_CHANGE: 'web_news_feed_language_change',
  NEWS_FEED_READ_MORE: 'web_news_feed_read_more',
  NEWS_FEED_NAV_FAVOURITE_TAB: 'web_nav_favourites_tab',
  NEWS_FEED_NAV_DAILY_TAB: 'web_nav_daily_tab',
  NEWS_FEED_COPY_NEWS: 'web_copy_news',
  NEWS_FEED_SHARE_NEWS: 'web_share_news',
  SHARED_NEWS_READ_MORE: 'web_shared_news_read_more',

  // Global Coffee Price
  COFFEE_PRICES_COUNTRY_DROPDOWN: 'web_coffee_prices_country_drop_down',

  // Global Differential
  GLOBAL_DIFF_COUNTRY_DROPDOWN: 'web_global_differentials_country_drop_down',
  // GLOBAL_DIFF_TOGGLE_ROW: 'web_global_differentials_toogle_row'

  // COFFEE REPORTS
  SELECTED_REPORT_NAME: 'web_selected_report_name',

  // SUPPORT
  SUPPORT_SUBMIT: 'web_submit_support',

  // Footer
  TERMS_AND_CONDITIONS_NAV: 'web_nav_terms_and_conditions',
  PRIVACY_POLICY_NAV: 'web_nav_privacy_policy',

  // Modal
  MODAL_REDIRECT: 'web_modal_auth/subscription_redirect',

  // Header-Action
  THEME_SWITCHED: 'web_theme-switch'
}

export const SCREEN_EVENTS = {
  ABOUT_US_SCREEN: 'web_about_us_screen',
  COFFEE_QUOTES_SCREEN: 'web_coffee_quotes_screen',
  NEWS_FEEDS_SCREEN: 'web_news_feeds_screen',
  NEWS_FEED_SHARED_PAGE: 'web_news_feed_shared_page',
  GLOBAL_RAW_COFFEE_PRICE_SCREEN: 'web_global_raw_coffee_price_screen',
  GLOBAL_DIFFERENTIAL_SCREEN: 'web_global_differential_screen',
  USER_COFFEE_REPORTS_SCREEN: 'web_coffee_reports_screen_user',
  SUBSCRIPTION_SCREEN: 'web_subscription_screen',
  PAYMENT_SCREEN: 'web_payment_screen',
  SUPPORT_SCREEN_USER: 'web_support_screen_user',
  SUPPORT_SCREEN_GUEST: 'web_support_screen_guest',
  USER_GUIDE_SCREEN: 'web_user_guide_screen',
  BILLIONAIRES_BREW_SCREEN: 'web_billionaires_brew_screen',

  LOGIN_SCREEN: 'web_login_screen',
  CREATE_ACCOUNT_SCREEN: 'web_create_account_screen',
  NOTIFICATION_SCREEN: 'web_notification_screen',
  GUEST_NEWS_FEEDS_SCREEN: 'web_guest_news_feeds_screen',
  GUEST_COFFEE_REPORTS_SCREEN: 'web_coffee_reports_screen_guest',
  GUEST_USER_GUIDE_SCREEN: 'web_user_guide_screen_guest',

  FORGOT_PASSWORD_SCREEN: 'web_forgot_password_screen',
  CHANGE_PASSWORD_SCREEN: 'web_change_password_screen'
}
